// extracted by mini-css-extract-plugin
module.exports = {"menu-button":"menuButton_menu-button__2WRFF","menu-button--loading":"menuButton_menu-button--loading__3wv_1"};